import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, UpperCasePipe } from '@angular/common';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { ModalDialogDirective } from '../../../directives/modal-dialog.directive';
import {
  EvaluationIssue,
  EvaluationResult,
  EvaluationSeverity,
  SessionEvaluation,
} from '../../../models/evaluation.model';

@Component({
  selector: 'app-evaluation-panel',
  imports: [NgClass, NgxSpinnerComponent, UpperCasePipe, ModalDialogDirective],
  templateUrl: './evaluation-panel.html',
  styleUrl: './evaluation-panel.scss',
})
export class EvaluationPanel {
  @Input() evaluation: SessionEvaluation | null = null;
  @Input() loading = false;
  @Input() error: string | null = null;
  @Output() closePanel = new EventEmitter<void>();
  @Output() reevaluate = new EventEmitter<void>();

  get result(): EvaluationResult | null {
    return this.evaluation?.result ?? null;
  }

  outcomeBadgeClasses(outcome: string | undefined): string {
    switch (outcome) {
      case 'success':
        return 'bg-green-100 text-green-800';
      case 'partial':
        return 'bg-yellow-100 text-yellow-800';
      case 'failure':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  severityBadgeClasses(sev: EvaluationSeverity): string {
    switch (sev) {
      case 'error':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'warn':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-blue-100 text-blue-800 border-blue-200';
    }
  }

  statusDotClasses(status: string | undefined): string {
    const s = (status || '').toLowerCase();
    if (s === 'ok' || s === 'success') return 'bg-green-500';
    if (s === 'error' || s === 'failed') return 'bg-red-500';
    return 'bg-gray-400';
  }

  trackIssue(_idx: number, issue: EvaluationIssue): string {
    return `${issue.where}|${issue.what}`;
  }

  trackStep(_idx: number, step: { step: string; ts?: string }): string {
    return `${step.ts ?? ''}|${step.step}`;
  }
}
